import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { RedirectService } from '../redirect/redirect.service';
import { SignInService } from './sign-in.service';
import { PaymentService } from '../payment.service';
import { LocalDBService } from '../local-db.service';
import { CapabilityEngineService } from '../capabilityEngine.service';

declare var $: any;



@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
    user: any = {};
    team: any = {};
    teamAuthentication: any = {};
    emailVerified: Boolean = false;
    errMessage: String;
    currentTeamName: String;
    emailForm: FormGroup;
    forgotEmailForm: FormGroup;
    teamName: any;
    teamNameForm: FormGroup;
    passwordForm: FormGroup;
    htmlData: any;
    isTeamValid: Boolean = false;
    isEmailValid: Boolean = false;
    userEmail: Boolean = true;
    imageList = [];
    constructor(
        private _signinservice: SignInService,
        private _router: Router,
        private _formBuilder: FormBuilder,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute,
        private _cookieService: CookieService,
        private _paymentService: PaymentService,
        private _localDBService: LocalDBService,
        private _capabilityEngineService : CapabilityEngineService
    ) {

        this._localDBService.deleteDB();

        let _queryParams = _activatedRoute.queryParams['_value'];
        if (_queryParams) {
            if (_queryParams.error) {
                console.log(new Error(_queryParams.error));
            }

            if (_queryParams.teams) {

                const teams = JSON.parse(_queryParams.teams);

                localStorage.setItem('userName', _queryParams.userName);
                localStorage.setItem('userEmail', _queryParams.userEmail);
                localStorage.setItem('teams', JSON.stringify(teams));

                this._router.navigateByUrl('/teamsSelection');

            } else {
                if (_queryParams.userName && _queryParams.userRole && _queryParams.teamName && _queryParams.teamId) {
                    localStorage.setItem('userName', _queryParams.userName);
                    localStorage.setItem('userRole', _queryParams.userRole);
                    localStorage.setItem('teamName', _queryParams.teamName);
                    localStorage.setItem('teamId', _queryParams.teamId);
                    if (_cookieService.get('userpreferences-tutorial') && _cookieService.get('userpreferences-tutorial') === '1' && !this._capabilityEngineService.isFormhound()) {
                        _cookieService.delete('userpreferences-tutorial');
                        this._router.navigateByUrl('/starttour');
                    } else {
                        this._redirectService.redirectBasedOnRoles();
                    }
                }
            }
        }
    }


    ngOnInit() {
        this.imageList = [
            { imageName: 'assets/images/Atlas_Copco_logo.svg' },
            { imageName: 'assets/images/barrick-client-logo.svg' },
            { imageName: 'assets/images/epiroc-logo.png' },
            { imageName: 'assets/images/lhoist-logo.svg' }
        ];
        // let currentTeamName;
        // if (localStorage.getItem('teamName')) {
        //     // console.log("have team name");
        //     currentTeamName = localStorage.getItem('teamName');
        // } else {
        //     // console.log("dont have team name");
        //     currentTeamName = '';
        // }
        // if (localStorage.getItem('userRole')) {
        //     this._redirectService.redirectBasedOnRoles();
        // }

        this.emailForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });
        this.passwordForm = this._formBuilder.group({
            password: ['', [Validators.required, Validators.minLength(8)]]
        });
        this.forgotEmailForm = this._formBuilder.group({
            resetPassword: ['', [Validators.required, Validators.email]]
        });
        // this.teamNameForm = this._formBuilder.group({
        //     teamName: [currentTeamName, [Validators.required]]
        // });
        if (this._activatedRoute.snapshot.queryParams.status === 'SESSION_TIMED_OUT') {
            $('#forcelogoutmodal').modal({
                backdrop: 'static',
                show: true
            });
        }
    }
    loginADAPI = () => {
        window.location.href = environment.client + '/api/user/ad-login/' + this.user.email;
    }

    verifyEmailId() {
        if (this.emailForm.valid) {
            this.errMessage = '';
            this.user.email = this.emailForm.value.email;
            // this.teamName = this.teamNameForm.value.teamName;
            this.user.email = _.toLower(this.user.email);
            this._signinservice.verifyEmailId(this.user.email)
                .subscribe(
                    (result: any) => {
                        // console.log(JSON.stringify(result));
                        if (result.data.role === 'operator') {
                            this.errMessage = 'You can\'t access the web panel. Contact your team administrator';
                        } else {
                            localStorage.setItem('authType', result.data.authDetails.authType);
                            if (result.data.authDetails.authType === 'azure' || result.data.authDetails.authType === 'auth0') {
                                this.loginADAPI();
                                return;
                            }

                            this.emailVerified = true;
                            this.isEmailValid = true;
                            this.errMessage = '';
                        }
                    },
                    err => {
                        console.error(err.error.message);
                        this.errMessage = err.error.message;
                    }
                );

        } else {
            this.validateAllFormFields(this.emailForm);
        }
    }
    verifyTeamName() {
        // Do perform validations on team name
        if (this.teamNameForm.valid) {
            this.team.teamName = this.teamNameForm.value.teamName;
            this._signinservice.verifyTeam(this.team).subscribe(
                (result: any) => {
                    console.log(result);
                    this.errMessage = '';
                    this.teamAuthentication = result.data;
                    this._redirectService.redirectBasedOnRoles();
                    this.teamName = this.teamNameForm.value.teamName;
                    this.isTeamValid = true;
                },
                err => {
                    console.error(err.error.message);
                    this.errMessage = err.error.message;
                }
            );
        } else {
            this.validateAllFormFields(this.teamNameForm);
        }
    }

    signIn() {
        if (this.passwordForm.valid && this.emailVerified) {
            this.errMessage = '';
            this.user.password = this.passwordForm.value.password;
            // this.user.teamName = this.team.teamName;
            this._signinservice.login(this.user)
                .subscribe(
                    (result: any) => {
                        let data = result.data;
                        if (result.success && data.tokens.authToken && data.tokens.refreshToken && data.userDetails) {
                            if (data.userDetails.role === 'operator') {
                                this.errMessage = 'You can\'t access the web panel. Contact your team administrator';
                                return true;
                            }

                            let teamsList = _.filter(data.userDetails.teams, (team) => {
                                return team.userRole !== 'operator';
                            });

                            //Generating WorkOrderId and InspectionId
                            this._localDBService.createInspectionDataSetUp(function () {

                            });

                            if(result.data && result.data.timezone) {
                                localStorage.setItem('timezone', result.data.timezone);
                            }
                            if (teamsList.length > 1) {

                                localStorage.setItem('userName', data.userDetails.name);
                                localStorage.setItem('userId', data.userDetails._id);
                                localStorage.setItem('userEmail', this.user.email);
                                localStorage.setItem('teams', JSON.stringify(teamsList));
                                if(data['hazardTemplateId']) {
                                    localStorage.setItem("hazardTemplateId", data['hazardTemplateId'])
                                }
                                if (data.userPreferences && data.userPreferences.web && data.userPreferences.web.tutorial === 1) {
                                    this._cookieService.set('userpreferences-tutorial', '1');
                                }
                                if (data.userPreferences && data.userPreferences.web && data.userPreferences.web.layout === 1) {
                                    this._cookieService.set('userpreferences-layout', '1');
                                } else {
                                    this._cookieService.set('userpreferences-layout', '0');
                                }
                                var navUrl = '/teamsSelection';
                                if (this._paymentService.getParamValue('redirectUrl') === 'initiatePayment') {

                                    navUrl = navUrl + '?redirectUrl=initiatePayment&plan=' + this._paymentService.getParamValue('plan')

                                }
                                this._router.navigateByUrl(navUrl);
                            } else {
                                const team = teamsList[0];
                                localStorage.setItem('userName', data.userDetails.name);
                                localStorage.setItem('userId', data.userDetails._id);
                                localStorage.setItem('userEmail', data.userDetails.email);
                                localStorage.setItem('userRole', team.userRole);
                                localStorage.setItem('teamName', team.teamDetails.name);
                                localStorage.setItem('teamId', team.teamDetails._id);
                                localStorage.setItem('teams', JSON.stringify(teamsList));

                                if(data['hazardTemplateId']) {
                                    localStorage.setItem("hazardTemplateId", data['hazardTemplateId'])
                                }


                                if (this._paymentService.getParamValue('redirectUrl') === 'initiatePayment') {

                                    this._paymentService.navigateToPayment();
                                } else {

                                    if (data.userPreferences && data.userPreferences.web && data.userPreferences.web.layout === 1) {
                                        this._cookieService.set('userpreferences-layout', '1');
                                    } else {
                                        this._cookieService.set('userpreferences-layout', '0');
                                    }
                                    if (data.userPreferences && data.userPreferences.web && data.userPreferences.web.tutorial === 1 && !this._capabilityEngineService.isFormhound()) {
                                        this._router.navigateByUrl('/starttour');
                                    } else {
                                        const role = localStorage.getItem("userRole");
                                        if(role && (role == "webAdmin" || role == "supervisor")) {
                                            if(result.data && result.data.defaultView) {
                                                const defaultView = result.data.defaultView;
                
                                                switch(defaultView) {
                                                    case "dashboard":
                                                        this._router.navigateByUrl('/dashboard');
                                                        return;
                                                    case "inspections":
                                                        this._router.navigateByUrl('/submittedForms');
                                                        return;
                                                    case "hazards":
                                                        const hazardTemplateId = localStorage.getItem("hazardTemplateId");
                                                        if(hazardTemplateId && hazardTemplateId.length > 0) {
                                                            this._router.navigateByUrl(`hazards/${hazardTemplateId}?isHazardForm=true`)
                                                        }
                                                        return;
                                                    case "incidents":
                                                        this._router.navigateByUrl('/incidentForms');
                                                        return;
                                                }
                                            }
                                        }

                                        this._redirectService.redirectBasedOnRoles();
                                    }
                                }
                            }
                        }
                    },
                    err => {
                        console.error(err.error.message);
                        if (err.error.message) {
                            this.errMessage = err.error.message;
                        }
                    }
                );
        } else {
            this.validateAllFormFields(this.passwordForm);
        }
    }


    isFieldValid(field: string) {
        if (field === 'email') {
            return !this.emailForm.get(field).valid && this.emailForm.get(field).touched;
        }
        if (field === 'password') {
            return !this.passwordForm.get(field).valid && this.passwordForm.get(field).touched;
        }
        // if (field === 'teamName') {
        //     return (
        //         !this.teamNameForm.get(field).valid &&
        //         this.teamNameForm.get(field).touched
        //     );
        // }
        if (field === 'resetPassword') {
            return (
                !this.forgotEmailForm.get(field).valid &&
                this.forgotEmailForm.get(field).touched
            );
        }
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field)
        };
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            console.log(field);
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    forgotPassword() {
        // console.log(
        //     "submit",
        //     this.forgotEmailForm.valid,
        //     this.forgotEmailForm.value
        // );
        if (!this.forgotEmailForm.valid) {
            return;
        }
        let Resetemail = { email: this.forgotEmailForm.value.resetPassword };
        console.log('email', this.forgotEmailForm.value.resetPassword);
        this._signinservice.forgotPassword(Resetemail).subscribe(
            (result: any) => {
                console.log(result);
                this.errMessage = '';
                this.userEmail = false;
            },
            err => {
                console.error(err.error.message);
                this.errMessage = err.error.message;
            }
        );
    }

    openForgotPasswordModal() {
        this.userEmail = true;
        this.errMessage = '';
        this.passwordForm.reset();
        this.forgotEmailForm.controls['resetPassword'].setValue(
            this.emailForm.value.email
        );
        console.log('set value', this.forgotEmailForm.value);
    }

    closeModal() {
        $('#forcelogoutmodal').modal('toggle');
        $('.modal-backdrop').remove();
    }
    resetTeam() {
        this.emailForm.reset();
        this.passwordForm.reset();
        this.isEmailValid = false;
        // this.isTeamValid = false;
    }
    resetEmail() {
        this.passwordForm.reset();
        this.user.email = '';
        this.isEmailValid = false;
        this.errMessage = '';
    }

    resetErrorMessage() {
        this.errMessage = '';
        // console.log('hello world' , this.errMessage);
    }

    sso() {
        // this._loginService.sso();
        console.log('sdf');
        window.location.href = '/api/user/ad-login';
    }
}



// WEBPACK FOOTER //
// ./src/app/sign-in/sign-in.component.ts